import { encode } from '@/utils/uuidSlugCodec'
import { v4 } from 'uuid'

export const createUrlSafeUuidV4 = () => encode(v4())
